import { render, staticRenderFns } from "./EventoCard.vue?vue&type=template&id=68bd1156&scoped=true"
import script from "./EventoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventoCard.vue?vue&type=style&index=0&id=68bd1156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd1156",
  null
  
)

export default component.exports